import { SectionWrapper } from '../components/SectionWrapper';

import styles from './AdoptionQuoteSection.module.css';

export function AdoptionQuoteSection() {
  return (
    <SectionWrapper background="soft" data-testid="institutions-section-adoption">
      <div className={styles.layout}>
        <figure className={styles.quote}>
          <blockquote>&quot;What if our faculty don&apos;t adopt it?&quot;</blockquote>
          <figcaption>The question every institutional pilot eventually asks.</figcaption>
        </figure>
        <div className={styles.response}>
          <p>
            Kudu is built around the adoption barrier: faculty can start from a
            complete course instead of a blank authoring tool.
          </p>
          <p>
            Setup takes minutes for a pre-built course, and departments can use
            no-cost pilots to prove fit before committing broadly.
          </p>
          <p>
            For faculty with unique materials, Kudu can build the course around
            their notes, slides, and assignments so the instructor keeps the
            intellectual center of the class.
          </p>
        </div>
      </div>
    </SectionWrapper>
  );
}
